import './index.scss'
import { useDispatch } from 'stimulus-use'
import ApplicationController from '@app/javascript/controllers/application_controller'
import { setCookie } from '@app/javascript/classes/cookies'

export class Controller extends ApplicationController {
  static targets = ['pill']

  doConnect() {
    useDispatch(this)
  }

  pillCleared({ currentTarget }) {
    const filterName = currentTarget.getAttribute('data-filter-name')
    const filterValues = JSON.parse(currentTarget.getAttribute('data-filter-values'))
    const rolledUp = currentTarget.getAttribute('data-rolled-up') === 'true'

    this.hideActiveFiltersWhenBecomingEmpty()
    this.tryOptimisticallyClearingTheTargetFilterValues(filterName, filterValues, rolledUp)
    this.dispatch('filterCleared', { filterName, filterValues })
  }

  clearAllPills(ev) {
    ev.preventDefault()
    this.hideActiveFilters()
  }

  hideActiveFiltersWhenBecomingEmpty() {
    const willBecomeEmptyAfterRemoval = this.pillTargets.length <= 1

    if (willBecomeEmptyAfterRemoval) this.hideActiveFilters()
  }

  hideActiveFilters() {
    this.element.setAttribute('hidden', true)
  }

  tryOptimisticallyClearingTheTargetFilterValues(filterName, filterValues, rolledUp) {
    // Find the target filter from the Filters sidebar
    const targetFilter = document.querySelector(
      `[data-controller~="filter"][data-filter-name*=${filterName}]`
    )
    const targetFilterController = targetFilter?.controllers?.filter

    if (filterName === 'policy_legislation_session') {
      const domain = window.location.hostname === 'localhost' ? 'localhost' : '.fiscalnote.com'
      setCookie('searchPage.activeSessions', false, { longLasting: true, path: '/', domain: domain })
    }

    if (!targetFilterController) return

    rolledUp
      ? targetFilterController.clearAll()
      : targetFilterController.clearValues(filterValues)
  }
}
